import { useMutation, UseMutationResult } from "@tanstack/react-query";
import axios from "../../utils/axiosinstance";
import { enum_api_uri } from "common/hooks/utils/enum";
import { useAuthStore } from "user/store/useAuthStore";

interface Request {
    m_password: string;
    new_password: string;
}

interface Response {
    data: null;
}

export const usePutPassword = (successCallback?: () => void): UseMutationResult<Response, Error, Request, unknown> => {
    // const accessToken = useAuthStore(state => state.accessToken);

    return useMutation<Response, Error, Request>({
        mutationFn: async ({ m_password, new_password }: Request) => {
            const response = await axios.put(
                enum_api_uri.user.put_password,
                {
                    m_password,
                    new_password,
                },
                // {
                //     headers: {
                //         Authorization: `Bearer ${accessToken}`,
                //     },
                // },
            );
            return response.data;
        },
        onSuccess: data => {
            successCallback?.();
        },
    });
};
